const SHADOW_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;

const SIZING_STYLE = [
  'letter-spacing',
  'line-height',
  'padding-top',
  'padding-bottom',
  'font-family',
  'font-weight',
  'font-size',
  'font-variant',
  'text-rendering',
  'text-transform',
  'width',
  'text-indent',
  'padding-left',
  'padding-right',
  'border-width',
  'box-sizing',
  'word-break',
  'white-space',
];

type TextareaSizingData = {
  paddingSize: number;
  borderSize: number;
  sizingStyles: string;
};

let hiddenTextarea: HTMLTextAreaElement | null = null;

export function getTextareaComputedStyle(textarea: HTMLTextAreaElement): TextareaSizingData {
  const style = window.getComputedStyle(textarea);
  const paddingSize =
    parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  const borderSize =
    parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  const sizingStyles = SIZING_STYLE.map((name) => `${name}:${style.getPropertyValue(name)}`).join(';');

  return {
    paddingSize,
    borderSize,
    sizingStyles,
  };
}
/**
 * @desc Textarea autoSize 동적 Height 계산
 *  - 입력 콘텐츠의 폰트/크기/행 간격등 요소에 따른 높이 계산시 브라우저마다의 일관된 값을 처리하도록 가상의 숨겨진 hiddenTextarea를 재사용합니다.
 *  - hiddenTextarea를 통해 해당 요소의 스타일을 적용하여 텍스트의 크기를 계산하고 실제로 보이는 textarea의 높이를 조절합니다.
 */
export function getTextareaAutoSizeStyles(
  sizingData: TextareaSizingData,
  value: string,
  minRows = 2,
  maxRows = Infinity,
) {
  const { paddingSize, borderSize, sizingStyles } = sizingData;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  hiddenTextarea.value = value;
  hiddenTextarea.setAttribute('style', `${sizingStyles};${SHADOW_TEXTAREA_STYLE}`);

  let minHeight: number | undefined = undefined;
  let maxHeight: number | undefined = undefined;
  let height = hiddenTextarea.scrollHeight + borderSize;

  hiddenTextarea.value = ' ';
  const singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
  if (minRows !== null) {
    minHeight = singleRowHeight * minRows + paddingSize + borderSize;
    height = Math.max(minHeight, height);
  }
  if (maxRows !== null) {
    maxHeight = singleRowHeight * maxRows + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
  }

  return {
    resize: 'none',
    height,
    ...(minHeight && { minHeight }),
    ...(maxHeight && { maxHeight }),
  };
}
